var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInnovate2024(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-11b8b03e-421a-46b6-acbe-87bf53c502e4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #be2bbb;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #2d2d62;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #8a1a9b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.9,65.5h-4.6v-23.2h4.6v23.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.9,56.5v9h-4.4v-8c0-.6.4-4.7-2.8-4.9-1.6,0-4.4.8-4.4,5.1v7.8h-4.4v-16.6h3.4l.6,2h.6c.7-.8,2.3-2.2,5-2.2,4.3,0,6.4,3.2,6.4,7.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.4,56.5v9h-4.4v-8c0-.6.4-4.7-2.8-4.9-1.6,0-4.4.8-4.4,5.1v7.8h-4.4v-16.6h3.4l.6,2h.6c.7-.8,2.3-2.2,5-2.2,4.3,0,6.4,3.2,6.4,7.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.3,57.3c0-5.3,4.1-8.5,8.6-8.5s8.4,3.2,8.4,8.4-4.1,8.5-8.5,8.5-8.4-3.2-8.4-8.4ZM307.9,57.2c0-2.6-1.5-4.6-4.1-4.6s-4.2,2-4.2,4.6,1.7,4.6,4.2,4.6,4.1-2,4.1-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M330.3,48.9l-5.4,16.6h-6.4l-5.4-16.6h4.4l3.8,12.2h.7l3.8-12.2s4.4,0,4.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348,62.3v3.2h-1c-1.9,0-3.3-.7-3.8-2.1-1,1.4-2.7,2.3-5.2,2.3-3.8,0-6.1-1.9-6.1-4.9,0-5.2,7.1-5.6,10.2-5.8,0-1.9-1.1-2.6-2.8-2.6s-2.5,1.4-2.5,1.4h-4.1c.3-3,2.7-5,6.8-5s6.7,2,6.7,6.8v4.4c0,1.9.7,2.4,2,2.4h0ZM342,58.6v-.3c-3,.3-6,.7-6,2.4,0,2.5,5.7,2.3,6-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.3,64.3s-1.4,1.4-3.9,1.4-5.9-2.2-5.9-5.5v-7.7h-3.3v-3.3h1.7c1.1,0,1.9-.8,1.9-2v-3.3h4v5h4.2v3.6h-4.2v7.4c0,1.1.9,2,2.1,2s1.9-.6,1.9-.6l1.6,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.6,58.5h-12.1c.5,2.5,2.5,3.4,4.4,3.4s3.2-1.4,3.2-1.4h4.2c-1.3,3.3-4.3,5.1-7.5,5.1s-8.4-3.4-8.4-8.6,3.9-8.3,8.3-8.3,8.6,3,8,9.7h0ZM366.7,55.1h7.5c-.5-2-1.9-2.8-3.5-2.8s-3.3,1-3.9,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.6,89.5c0,7.1-4.2,10.1-9.3,10.1s-9.4-3-9.4-10.1v-13.3h4.6v12.9c0,3.8,1.6,6.1,4.8,6.1s4.7-2.3,4.7-6.1v-12.9h4.6v13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.1,89.7h-1.9v9.8h-4.4v-23.2h4.4v9.1h1.9l5.9-9.1h5.1l-7.2,11.3,8.2,11.9h-5.1l-6.8-9.8h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.4,
    y: 19.8,
    width: 102.2,
    height: 102.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.3,31h-11.9l-16,17.1v-17.1h-23.2v22.7c0,4.9-3.6,7.7-8.3,7.7s-8.3-2.8-8.3-7.7v-22.7h-11.9v22.8c0,10.2,8.3,16.1,17.6,17h-17.6v39.9h11.9v-14.8h5.2l11,14.8h51.6v-8.1h-14v-23.7h14v-10.5l-17.1-17.5,17.1-17.4v-2.5h0ZM72.5,58.7v18.5c-2.5-4.3-8.4-6.3-17-6.3,7.7-.8,14.9-4.9,17-12.2h0ZM44.5,78.9h10.9c4.5,0,6.3,1.7,6.3,4.5s-1.8,4.5-6.3,4.5h-10.9v-9ZM86.4,102.7h-14v5.6l-9.8-12.9c7.5-1.4,11.3-5.2,11.3-12s-.2-3.1-.7-4.5h13.1v23.7h0ZM100.4,70.9h-16v-17.1l16,17.1Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 123.5,
    y: 89,
    width: 65.5,
    height: 33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 173.7,
    y: 19.8,
    width: 52.1,
    height: 24.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "173.7 44.6 173.7 19.8 173.7 7 123.5 7 123.5 19.8 123.5 105 189.1 105 189.1 122 225.7 122 225.7 44.6 173.7 44.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovate2024);
export default __webpack_public_path__ + "static/media/innovate - 2024.c21fbbb8259c15b23df64120d49f5bb1.svg";
export { ForwardRef as ReactComponent };